'use client';

import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "A IA também agenda consultas?",
    answer: "Não. O agendamento é confirmado manualmente pela secretária/consultório na plataforma. Assim que a consulta é cadastrada, o paciente recebe mensagem automática de confirmação e lembrete. A IA atua exclusivamente no pós-atendimento.",
  },
  {
    question: "O que acontece em caso de uma complicação real?",
    answer: "O sistema é treinado para detectar palavras-chave e sinais de risco nas mensagens dos pacientes. Nesses casos, gera notificação imediata na plataforma, alertando o médico ou a equipe.",
  },
  {
    question: "Quanto tempo leva a implementação?",
    answer: "A implementação leva cerca de 15 minutos e nossa equipe oferece suporte completo durante o processo.",
  },
  {
    question: "É compatível com todas as especialidades?",
    answer: "Sim, o sistema é configurável por protocolo e se adapta a qualquer especialidade, área clínica ou cirúrgica.",
  },
  {
    question: "O MedFollow é seguro e está de acordo com a LGPD?",
    answer: "Totalmente. A segurança é nossa prioridade. Utilizamos criptografia de ponta e todos os dados são armazenados em servidores seguros no Brasil, em total conformidade com as normas da LGPD.",
  },
  {
    question: "Como funciona o cancelamento?",
    answer: "O cancelamento é livre, sem multa e sem burocracia. Você pode cancelar a qualquer momento.",
  },
];

export default function Faq() {
  return (
    <section id="faq" className="py-10 sm:py-16">
      <div
        className="container mx-auto px-4"
      >
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="font-headline text-3xl tracking-[-0.04em] leading-[1.1] text-black sm:text-4xl font-semibold">
            Perguntas Frequentes
          </h2>
          <p className="mt-4 text-lg text-foreground/70 tracking-tight">
            Tudo o que você precisa saber sobre o MedFollow.
          </p>
        </div>
        <div className="mx-auto mt-12 max-w-3xl">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`}>
                <AccordionTrigger className="text-left font-semibold tracking-tight">{faq.question}</AccordionTrigger>
                <AccordionContent>
                  <p className="text-base text-foreground/80 tracking-tight">{faq.answer}</p>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
